import { useNationality } from "@faire/deprecated-retailer-visitor-shared/hooks/retailer/useNationality";
import { useStyleQuizStore } from "@faire/deprecated-retailer-visitor-shared/hooks/styleQuiz/useStyleQuizStore";
import { StoreType } from "@faire/web/common/StoreType";

const PARTIAL_RETAILER_STORE_TYPES: Array<string | undefined> = [
  StoreType.CAFE_OR_RESTAURANT,
  StoreType.SPA_OR_SALON,
];

export const useGetStoreType = () => {
  const { styleQuiz } = useStyleQuizStore();
  const { isAmerican } = useNationality();
  const storeType = styleQuiz?.store_type;

  const isPartialRetailersStoreType =
    PARTIAL_RETAILER_STORE_TYPES.includes(storeType);
  const shouldShowPartialRetailersBasedOnStoreType =
    isPartialRetailersStoreType && isAmerican;

  return {
    storeType,
    shouldShowPartialRetailersBasedOnStoreType,
  };
};
